import {store} from '../store/store';
import {apiSlice} from '../store/api/apiSlice';

const MODULE_BILLING = 'billing.feature';
const MODULE_BILLING_INVOICING = 'billing.invoicing';
const MODULE_BILLING_CREDIT_CARD_PAYMENT = 'billing.credit_card.payment';

/**
 * Returns true or false whether a module is available for the current instance.  Default false
 *
 * @param {string} moduleString A period separated, hierarchical string of the module
 * @returns {boolean}
 */
const isModuleAvailable = (moduleString) => {
    try {
       const moduleConfig = apiSlice.endpoints.getModuleConfig.select()(
            store.getState()
        );
        if (moduleConfig.data) {
            return getModuleFromJson(moduleString.split('.'), moduleConfig.data);
        }
        return false;
    } catch (error) {
        return false;
    }
};
/**
 * Recursively searches the JSON array using the key, until it is found, or defaults to false if undefined
 * Example:
 * Returns true
 * 1st run: moduleArray = ['billing', 'feature'] configJson = [billing => ['feature' => true]]
 * 2nd run: moduleArray = ['feature']            configJson = ['feature => true']
 *
 * Returns false
 * 1st run: moduleArray = ['billing', 'credit_card', 'payment'] configJson = [billing => ['feature' => true]]
 * 2nd run: moduleArray = ['credit_card_payment']            configJson = undefined
 *
 * @param moduleArray
 * @param configJson
 * @returns {boolean}
 */
const getModuleFromJson = (moduleArray, configJson) => {
    // Check if site module permissions are loaded
    if (configJson === undefined) {
        return false;
    }
    // Take the first item from the array and try to find the key in the JSON
    let target = moduleArray[0];
    // val is either undefined, an array, or a boolean value retrieved from indexing into the JSON
    let val = configJson[target];
    if (val === undefined) {
        return false;
    } else if (typeof val === 'boolean') {
        return val;
    }
    // At this point, it's another array, so keep searching

    // Call function again, removing the first item from moduleArray,
    // and pass in the current JSON array at the current depth
    return getModuleFromJson(moduleArray.slice(1), val);
};

export {
    MODULE_BILLING,
    MODULE_BILLING_INVOICING,
    MODULE_BILLING_CREDIT_CARD_PAYMENT,
    isModuleAvailable,
};
